import { schema } from 'normalizr';

const SubscriptionSchema = {
	CREATED_SUBSCRIPTIONS: new schema.Array(new schema.Entity('subscriptions', {}, { idAttribute: 'id' })),
	CREATED_ADHOC_SUBSCRIPTIONS: new schema.Array(new schema.Entity('subscriptions', {}, { idAttribute: 'id' })),
	SUBSCRIPTION: new schema.Entity('subscription', {}, { idAttribute: 'id' }),
	SUBSCRIPTIONS: {
		content: [new schema.Entity('subscriptions', {}, { idAttribute: 'providerAtSendingFacilityId' })]
	},
	VALIDATE_ADDRESS: new schema.Entity('validateAddress', {}, { idAttribute: 'directAddress' }),
	VALIDATE_NPI: new schema.Entity('npiDetails'),
	HPD_DETAILS:  new schema.Entity('hpdDetails'),
	VALIDATE_SUBSCRIPTION: new schema.Array(new schema.Entity('validateSubscription', {}, { idAttribute: 'id' }))
};

export default SubscriptionSchema;
